module.exports = __webpack_public_path__ + "files/ca8444fe5a62ed83889754f108f8f28c.svg";